import { makeFetchReducer, namespaceReducer } from 'utils/store';
import { NAMESPACE, PATH } from '../const';

const reducer = makeFetchReducer(PATH);

export default namespaceReducer(NAMESPACE, reducer);
